export default __webpack_public_path__ + "static/media/Background_00253.209db8c0.png";